(function () {
	"use strict";

	angular.module("swurveys.maker")
		.factory("confirmationModal", vanillaConfirmModal);


	angular.module("swurveys.maker")
		.factory("deleteModal", deleteModal);


    function deleteModal(ModalService) {

		return {
			show :  function(action, info) {
				var header = "Are you sure you want to "+action+"?";
				var confirmationMessage = "This action can not be undone. Are you sure you want to "+action+" this?";
				return newConfirmDialog(ModalService, action, info, header, confirmationMessage);
			}
		};
    }

    function vanillaConfirmModal(ModalService)
    {
    	return {
    		show : function(action, info, header, confirmationMessage) {
    			return newConfirmDialog(ModalService, action, info, header, confirmationMessage);
    		}
    	};
    }

	var newConfirmDialog = function (ModalService, action, info, header, confirmationMessage) {
			return ModalService.showModal({
					templateUrl: "app/modals/confirmation/confirmation.html",
					controller: ["$element", "close", function ($element, close) {
						this.action = action;
						this.info = info;
						this.header = header;
						this.confirmationMessage = confirmationMessage;

						this.close = function (confirm) {
							close(confirm, 500);
							$(".modal-backdrop")
								.remove();
						};
					}],
					controllerAs: "modal"
				});
		};

}());
